// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1zu8P","dragIcon":"Choice_dragIcon__XVv1Z","left":"Choice_left__33suq","input":"Choice_input__22ZtX"};